<template>
  <sweet-modal
    ref="modal"
    :hide-close-button="true"
    width="620px"
  >
    <builderall-loader
      :loading="loading"
      :text="`${$t('ct-ai-loading-message-1')}|${$t('ct-ai-loading-message-2')}|${$t('ct-ai-loading-message-3')}|${$t('ct-ai-loading-message-4')}|${$t('ct-ai-loading-message-5')}|${$t('ct-ai-loading-message-6')}`"
      carousel="true"
    >
      <div class="popup-header">
        <svg width="27" height="26" viewBox="0 0 27 26" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M4.87884 3.49719C7.5226 1.47922 10.7529 0.664149 13.8281 1.00793C13.9901 1.02609 14.1472 1.07665 14.29 1.1554C14.4327 1.23418 14.5583 1.34051 14.6601 1.4679C14.7619 1.59537 14.8384 1.74182 14.8837 1.89856C14.9289 2.05509 14.9428 2.21907 14.9247 2.38098C14.9066 2.54311 14.8561 2.70004 14.7773 2.8429C14.6985 2.98577 14.5923 3.11215 14.4648 3.21399C14.3375 3.31561 14.1916 3.39137 14.0351 3.43665C13.8784 3.48193 13.7138 3.49578 13.5517 3.47766C11.0977 3.20331 8.51055 3.85076 6.38665 5.4718C2.01192 8.81103 1.17731 15.0277 4.51653 19.4025C7.85571 23.7768 14.0716 24.6114 18.4462 21.2726C20.5934 19.6337 21.8896 17.3453 22.2617 14.8927C22.2818 14.728 22.3343 14.5688 22.4169 14.4249C22.4997 14.2809 22.6108 14.1543 22.7431 14.0538C22.8753 13.9535 23.0266 13.881 23.1874 13.84C23.3484 13.7989 23.5163 13.7907 23.6806 13.8156C23.8449 13.8404 24.0028 13.8976 24.1445 13.9845C24.286 14.0714 24.4082 14.1863 24.5048 14.3214C24.6014 14.4565 24.6706 14.6095 24.707 14.7716C24.7433 14.9336 24.7463 15.1014 24.7167 15.2648C24.25 18.341 22.6081 21.2213 19.954 23.2472C14.5119 27.4011 6.69492 26.3514 2.54095 20.9093C-1.61266 15.4672 -0.563111 7.65108 4.87884 3.49719ZM12.707 11.0597C12.8785 11.0598 13.0458 11.1118 13.1874 11.2081C13.3292 11.3046 13.4385 11.4414 13.5009 11.6007L13.7783 12.3019C13.8208 12.4106 13.8852 12.51 13.9677 12.5929C14.0503 12.6758 14.1498 12.7411 14.2587 12.7843L14.9609 13.0597C15.1202 13.1229 15.2571 13.2328 15.3534 13.3741C15.4498 13.5157 15.5019 13.6836 15.5019 13.8546C15.5018 14.0255 15.4497 14.1927 15.3534 14.3341C15.2571 14.4754 15.1202 14.5853 14.9609 14.6486L14.2587 14.9259C14.15 14.9689 14.0513 15.0338 13.9687 15.1163C13.8861 15.1989 13.821 15.2979 13.7783 15.4064L13.5009 16.1095C13.4385 16.2688 13.3292 16.4056 13.1874 16.5021C13.0458 16.5984 12.8785 16.6504 12.707 16.6505C12.5353 16.6505 12.3673 16.5985 12.2255 16.5021C12.0838 16.4056 11.9744 16.2688 11.912 16.1095L11.6347 15.4064C11.592 15.298 11.5277 15.1989 11.4452 15.1163C11.3626 15.0338 11.263 14.9689 11.1542 14.9259L10.4521 14.6486C10.2927 14.5853 10.1559 14.4755 10.0595 14.3341C9.96323 14.1927 9.91116 14.0255 9.91106 13.8546C9.91106 13.6836 9.96314 13.5157 10.0595 13.3741C10.1559 13.2328 10.2927 13.1229 10.4521 13.0597L11.1542 12.7843C11.2632 12.7417 11.3626 12.6765 11.4452 12.5939C11.5278 12.5113 11.5923 12.4125 11.6347 12.3038L11.912 11.6007C11.9744 11.4414 12.0838 11.3046 12.2255 11.2081C12.3673 11.1116 12.5353 11.0597 12.707 11.0597ZM19.2284 0.500122C19.489 0.500122 19.7438 0.578365 19.9589 0.724731C20.1741 0.871239 20.3398 1.07949 20.4345 1.32141L21.5878 4.24231C21.6529 4.40762 21.7511 4.55792 21.8769 4.68372C22.0028 4.80958 22.1534 4.90834 22.3193 4.97375L25.2411 6.12708C25.4832 6.22317 25.6906 6.38977 25.8368 6.60461C25.9831 6.81953 26.0615 7.07347 26.0615 7.33313C26.0614 7.5926 25.983 7.84588 25.8368 8.06067C25.6906 8.27549 25.4832 8.4421 25.2411 8.53821L22.3193 9.69153C22.1538 9.7566 22.0037 9.85533 21.8779 9.98059C21.752 10.106 21.6532 10.2561 21.5878 10.421L20.4345 13.3448C20.3398 13.5866 20.174 13.7941 19.9589 13.9406C19.7437 14.087 19.4891 14.1652 19.2284 14.1652C18.9679 14.1651 18.7131 14.087 18.498 13.9406C18.283 13.7941 18.1171 13.5866 18.0224 13.3448L16.87 10.423C16.8047 10.2582 16.7057 10.1088 16.58 9.98352C16.4542 9.85821 16.3041 9.75958 16.1386 9.69446L13.2167 8.54114C12.9746 8.44505 12.7663 8.27851 12.62 8.0636C12.4739 7.84876 12.3964 7.59461 12.3964 7.33508C12.3965 7.07574 12.474 6.82225 12.62 6.60754C12.7663 6.39263 12.9746 6.22609 13.2167 6.13L16.1406 4.97668C16.3061 4.9114 16.4565 4.81249 16.582 4.68665C16.7074 4.56081 16.8057 4.41056 16.87 4.24524L18.0224 1.32141C18.1171 1.07952 18.2828 0.871237 18.498 0.724731C18.7131 0.578277 18.9679 0.500179 19.2284 0.500122ZM23.8876 1.74231C23.9448 1.74235 24.0005 1.75998 24.0478 1.79211C24.0951 1.82429 24.1315 1.86986 24.1523 1.92297V1.922L24.245 2.15637C24.2593 2.19252 24.281 2.22553 24.3085 2.25305C24.3361 2.28057 24.3689 2.30216 24.4052 2.31653L24.6396 2.4093C24.6926 2.43048 24.7384 2.46674 24.7704 2.51379C24.8024 2.56092 24.8193 2.61706 24.8193 2.67395C24.8193 2.73064 24.8022 2.78611 24.7704 2.83313C24.7384 2.88026 24.6926 2.9174 24.6396 2.9386L24.4052 3.03137C24.369 3.04574 24.3361 3.06734 24.3085 3.09485C24.281 3.12236 24.2593 3.15541 24.245 3.19153L24.1523 3.4259C24.1314 3.47888 24.095 3.52466 24.0478 3.55676C24.0006 3.5888 23.9447 3.60555 23.8876 3.60559C23.8303 3.60559 23.7738 3.58894 23.7265 3.55676C23.6793 3.52462 23.6428 3.4789 23.622 3.4259L23.5302 3.19153C23.5159 3.1554 23.4943 3.12234 23.4667 3.09485C23.4392 3.06742 23.4063 3.04567 23.37 3.03137L23.1357 2.9386C23.0826 2.9174 23.0368 2.88026 23.0048 2.83313C22.9729 2.78607 22.956 2.73072 22.956 2.67395C22.956 2.61706 22.9728 2.56092 23.0048 2.51379C23.0368 2.46683 23.0828 2.43045 23.1357 2.4093L23.37 2.31653C23.4435 2.28774 23.5008 2.22954 23.5302 2.15637L23.622 1.92297C23.6427 1.87 23.6794 1.82427 23.7265 1.79211C23.7738 1.75994 23.8303 1.74231 23.8876 1.74231Z" fill="url(#paint0_linear_223_1776)"/>
          <defs>
            <linearGradient id="paint0_linear_223_1776" x1="19.2288" y1="0.500122" x2="19.2288" y2="14.1656" gradientUnits="userSpaceOnUse">
              <stop stop-color="#0072E1"/>
              <stop offset="1" stop-color="#003E7B"/>
            </linearGradient>
          </defs>
        </svg>
        <span>{{ $t('ct-ai-website-builder') }}</span>
        <button class="skip-btn" @click="skipCreation">{{ $t('ct-skip') }}</button>
      </div>
      <div class="popup-body ba-grid ba-gp-1 ba-pd-t-1">
        <p class="ba-text-center">{{ $t('ct-ai-website-builder-description') }}</p>
        <div class="box-input ba-grid ba-gp-02">
          <label for="website-name">{{ $t('ct-ai-brand-website-name') }}</label>
          <input
            id="website-name"
            :placeholder="$t('ct-ai-brand-website-name-placeholder')"
            :class="{'ba-error': nameError && !isFormValidBool}"
            v-model="form.name"
            type="text"
            class="ba-input ba-md"
          >
          <span
            v-if="nameError && !isFormValidBool"
            class="ba-color-red1 error-message"
          >
            {{ nameError }}
          </span>
        </div>
        <div class="box-input ba-grid ba-gp-02">
          <div class="ba-flex ba-jc-sb ba-gp-1 ba-ai-end">
            <label for="website-description">{{ $t('ct-description') }}</label>
            <p class="website-description-qty">{{ form.description ? form.description.length : 0 }}/500</p>
          </div>
          <textarea
            id="website-description"
            :placeholder="$t('ct-ai-description-placeholder')"
            :class="{'ba-error': (descriptionError && !isFormValidBool) || (form.description && form.description.length > 500)}"
            v-model="form.description"
            type="text"
            class="ba-input ba-md"
          />
          <span
            v-if="descriptionError && !isFormValidBool"
            class="ba-color-red1 error-message"
          >
            {{ descriptionError }}
          </span>
          <div :class="promptStatusClass">
            <div class="prompt-status-1" />
            <div class="prompt-status-2" />
            <div class="prompt-status-3" />
          </div>
          <span class="instructions" v-text="promptStatusText" />
        </div>
        <div class="box-radio ba-grid ba-gp-1">
          <div class="ba-grid">
            <label>{{ $t('ct-ai-business-focus') }}</label>
            <span
              v-if="!form.focus && !isFormValidBool"
              class="ba-color-red1 error-message"
              v-text="$t('ct-ai-validation-focus')"
            />
          </div>
          <div class="radio-grid">
            <label v-for="option in websiteFocusOptions" :key="option.value">
              <input
                v-model="form.focus"
                :value="option.value"
                type="radio"
                name="website-focus"
              >
              {{ option.label }}
            </label>
          </div>
        </div>
        <div class="quick-note ba-w-100 ba-flex ba-jc-center ba-text-center">
          <span v-text="$t('ct-ai-quick-note')" />
        </div>
        <div class="box-input ba-grid ba-gp-02">
          <label for="website-language">{{ $t('ct-language') }}</label>
          <select
            v-model="form.language"
            class="ba-select ba-md"
            name="website-language"
          >
            <option
              v-for="language in languages"
              :key="language.value"
              :value="language.value"
            >
              {{ language.label }}
            </option>
          </select>
        </div>
      </div>
      <div class="popup-bottom ba-pd-t-1">
        <button
          class="generate-button"
          @click="createWebsite"
        >
          <svg width="22" height="22" viewBox="0 0 27 26" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4.87884 3.49719C7.5226 1.47922 10.7529 0.664149 13.8281 1.00793C13.9901 1.02609 14.1472 1.07665 14.29 1.1554C14.4327 1.23418 14.5583 1.34051 14.6601 1.4679C14.7619 1.59537 14.8384 1.74182 14.8837 1.89856C14.9289 2.05509 14.9428 2.21907 14.9247 2.38098C14.9066 2.54311 14.8561 2.70004 14.7773 2.8429C14.6985 2.98577 14.5923 3.11215 14.4648 3.21399C14.3375 3.31561 14.1916 3.39137 14.0351 3.43665C13.8784 3.48193 13.7138 3.49578 13.5517 3.47766C11.0977 3.20331 8.51055 3.85076 6.38665 5.4718C2.01192 8.81103 1.17731 15.0277 4.51653 19.4025C7.85571 23.7768 14.0716 24.6114 18.4462 21.2726C20.5934 19.6337 21.8896 17.3453 22.2617 14.8927C22.2818 14.728 22.3343 14.5688 22.4169 14.4249C22.4997 14.2809 22.6108 14.1543 22.7431 14.0538C22.8753 13.9535 23.0266 13.881 23.1874 13.84C23.3484 13.7989 23.5163 13.7907 23.6806 13.8156C23.8449 13.8404 24.0028 13.8976 24.1445 13.9845C24.286 14.0714 24.4082 14.1863 24.5048 14.3214C24.6014 14.4565 24.6706 14.6095 24.707 14.7716C24.7433 14.9336 24.7463 15.1014 24.7167 15.2648C24.25 18.341 22.6081 21.2213 19.954 23.2472C14.5119 27.4011 6.69492 26.3514 2.54095 20.9093C-1.61266 15.4672 -0.563111 7.65108 4.87884 3.49719ZM12.707 11.0597C12.8785 11.0598 13.0458 11.1118 13.1874 11.2081C13.3292 11.3046 13.4385 11.4414 13.5009 11.6007L13.7783 12.3019C13.8208 12.4106 13.8852 12.51 13.9677 12.5929C14.0503 12.6758 14.1498 12.7411 14.2587 12.7843L14.9609 13.0597C15.1202 13.1229 15.2571 13.2328 15.3534 13.3741C15.4498 13.5157 15.5019 13.6836 15.5019 13.8546C15.5018 14.0255 15.4497 14.1927 15.3534 14.3341C15.2571 14.4754 15.1202 14.5853 14.9609 14.6486L14.2587 14.9259C14.15 14.9689 14.0513 15.0338 13.9687 15.1163C13.8861 15.1989 13.821 15.2979 13.7783 15.4064L13.5009 16.1095C13.4385 16.2688 13.3292 16.4056 13.1874 16.5021C13.0458 16.5984 12.8785 16.6504 12.707 16.6505C12.5353 16.6505 12.3673 16.5985 12.2255 16.5021C12.0838 16.4056 11.9744 16.2688 11.912 16.1095L11.6347 15.4064C11.592 15.298 11.5277 15.1989 11.4452 15.1163C11.3626 15.0338 11.263 14.9689 11.1542 14.9259L10.4521 14.6486C10.2927 14.5853 10.1559 14.4755 10.0595 14.3341C9.96323 14.1927 9.91116 14.0255 9.91106 13.8546C9.91106 13.6836 9.96314 13.5157 10.0595 13.3741C10.1559 13.2328 10.2927 13.1229 10.4521 13.0597L11.1542 12.7843C11.2632 12.7417 11.3626 12.6765 11.4452 12.5939C11.5278 12.5113 11.5923 12.4125 11.6347 12.3038L11.912 11.6007C11.9744 11.4414 12.0838 11.3046 12.2255 11.2081C12.3673 11.1116 12.5353 11.0597 12.707 11.0597ZM19.2284 0.500122C19.489 0.500122 19.7438 0.578365 19.9589 0.724731C20.1741 0.871239 20.3398 1.07949 20.4345 1.32141L21.5878 4.24231C21.6529 4.40762 21.7511 4.55792 21.8769 4.68372C22.0028 4.80958 22.1534 4.90834 22.3193 4.97375L25.2411 6.12708C25.4832 6.22317 25.6906 6.38977 25.8368 6.60461C25.9831 6.81953 26.0615 7.07347 26.0615 7.33313C26.0614 7.5926 25.983 7.84588 25.8368 8.06067C25.6906 8.27549 25.4832 8.4421 25.2411 8.53821L22.3193 9.69153C22.1538 9.7566 22.0037 9.85533 21.8779 9.98059C21.752 10.106 21.6532 10.2561 21.5878 10.421L20.4345 13.3448C20.3398 13.5866 20.174 13.7941 19.9589 13.9406C19.7437 14.087 19.4891 14.1652 19.2284 14.1652C18.9679 14.1651 18.7131 14.087 18.498 13.9406C18.283 13.7941 18.1171 13.5866 18.0224 13.3448L16.87 10.423C16.8047 10.2582 16.7057 10.1088 16.58 9.98352C16.4542 9.85821 16.3041 9.75958 16.1386 9.69446L13.2167 8.54114C12.9746 8.44505 12.7663 8.27851 12.62 8.0636C12.4739 7.84876 12.3964 7.59461 12.3964 7.33508C12.3965 7.07574 12.474 6.82225 12.62 6.60754C12.7663 6.39263 12.9746 6.22609 13.2167 6.13L16.1406 4.97668C16.3061 4.9114 16.4565 4.81249 16.582 4.68665C16.7074 4.56081 16.8057 4.41056 16.87 4.24524L18.0224 1.32141C18.1171 1.07952 18.2828 0.871237 18.498 0.724731C18.7131 0.578277 18.9679 0.500179 19.2284 0.500122ZM23.8876 1.74231C23.9448 1.74235 24.0005 1.75998 24.0478 1.79211C24.0951 1.82429 24.1315 1.86986 24.1523 1.92297V1.922L24.245 2.15637C24.2593 2.19252 24.281 2.22553 24.3085 2.25305C24.3361 2.28057 24.3689 2.30216 24.4052 2.31653L24.6396 2.4093C24.6926 2.43048 24.7384 2.46674 24.7704 2.51379C24.8024 2.56092 24.8193 2.61706 24.8193 2.67395C24.8193 2.73064 24.8022 2.78611 24.7704 2.83313C24.7384 2.88026 24.6926 2.9174 24.6396 2.9386L24.4052 3.03137C24.369 3.04574 24.3361 3.06734 24.3085 3.09485C24.281 3.12236 24.2593 3.15541 24.245 3.19153L24.1523 3.4259C24.1314 3.47888 24.095 3.52466 24.0478 3.55676C24.0006 3.5888 23.9447 3.60555 23.8876 3.60559C23.8303 3.60559 23.7738 3.58894 23.7265 3.55676C23.6793 3.52462 23.6428 3.4789 23.622 3.4259L23.5302 3.19153C23.5159 3.1554 23.4943 3.12234 23.4667 3.09485C23.4392 3.06742 23.4063 3.04567 23.37 3.03137L23.1357 2.9386C23.0826 2.9174 23.0368 2.88026 23.0048 2.83313C22.9729 2.78607 22.956 2.73072 22.956 2.67395C22.956 2.61706 22.9728 2.56092 23.0048 2.51379C23.0368 2.46683 23.0828 2.43045 23.1357 2.4093L23.37 2.31653C23.4435 2.28774 23.5008 2.22954 23.5302 2.15637L23.622 1.92297C23.6427 1.87 23.6794 1.82427 23.7265 1.79211C23.7738 1.75994 23.8303 1.74231 23.8876 1.74231Z" fill="url(#paint0_linear_223_1776)"/>
            <defs>
              <linearGradient id="paint0_linear_223_1776" x1="19.2288" y1="0.500122" x2="19.2288" y2="14.1656" gradientUnits="userSpaceOnUse">
                <stop stop-color="#0072E1"/>
                <stop offset="1" stop-color="#003E7B"/>
              </linearGradient>
            </defs>
          </svg>
          {{ $t('ct-ai-create-website') }}
        </button>
      </div>
    </builderall-loader>
  </sweet-modal>
</template>

<script>
import { SweetModal } from "sweet-modal-vue";
import { startAiTemplateGeneration, getAiTemplateGenerationStatus } from "../../../js/services/editor/website";

export default {
  components: {
    SweetModal
  },
  props: ["template"],
  data() {
    return {
      websiteFocusOptions: [
        { value: 'product',        label: this.$t('ct-ai-product') },
        { value: 'service',        label: this.$t('ct-ai-service') },
        { value: 'courses',        label: this.$t('ct-ai-courses') },
        { value: 'lead-capture',   label: this.$t('ct-ai-lead-capture') },
        { value: 'personal-brand', label: this.$t('ct-ai-personal-brand') },
        { value: 'membership',     label: this.$t('ct-ai-membership') },
        { value: 'promotions',     label: this.$t('ct-ai-promotions') },
        { value: 'agency',         label: this.$t('ct-ai-agency') },
        { value: 'blog-media',     label: this.$t('ct-ai-blog-media') }
      ],
      languages: [
        { value: 'en_US', label: this.$t('ct-en-us') },
        { value: 'pt_BR', label: this.$t('ct-pt-br') },
        { value: 'es_ES', label: this.$t('ct-es-es') },
        { value: 'fr_FR', label: this.$t('ct-fr-fr') },
        { value: 'de_DE', label: this.$t('ct-de-de') },
        { value: 'it_IT', label: this.$t('ct-it-it') },
      ],
      form: {
        name: null,
        description: null,
        focus: null,
        language: 'en_US'
      },
      errors: {},
      loading: false,
      generation: {
        id: null,
        status: 'PENDING',
        interval: null
      },
      descriptionHealth: [80, 160],
      isFormValidBool: true
    };
  },
  computed: {
    nameError() {
      if (!this.form.name) return this.$t('ct-ai-validation-brand-website-name');
      if (this.form.name.length > 255) return this.$t('ct-ai-validation-name-characters');
      return null;
    },
    descriptionError() {
      if (!this.form.description) return this.$t('ct-ai-validation-description');
      if (this.form.description.length > 500) return this.$t('ct-ai-validation-description-characters');
      return null;
    },
    promptStatusClass() {
      if (!this.form.description) return 'prompt-status-box';
      const len = this.form.description.length;
      return `prompt-status-box ${len < this.descriptionHealth[0] ? 'red' : len < this.descriptionHealth[1] ? 'yellow' : 'green'}`;
    },
    promptStatusText() {
      if (!this.form.description) return '';
      const len = this.form.description.length;
      return len < this.descriptionHealth[0] ? this.$t('ct-prompt-health-red') : len < this.descriptionHealth[1] ? this.$t('ct-prompt-health-yellow') : this.$t('ct-prompt-health-green');
    },
  },
  mounted() {
    this.form.language = localStorage.getItem('user_language') || 'en_US';
  },
  methods: {
    skipCreation() {
      this.$emit('save');
    },
    isFormValid() {
      return !this.nameError && !this.descriptionError && !!this.form.focus;
    },
    apiUrl() {
      return typeof process.env.API_URL !== 'undefined' ? process.env.API_URL : 'https://cheetah-api.builderall.com';
    },
    async createWebsite() {
      if (!this.isFormValid()) {
        this.isFormValidBool = false;
        return;
      }

      this.isFormValidBool = true;
      this.loading = true;

      const formData = {
        name: this.form.name,
        description: this.form.description,
        focus: this.form.focus,
        language: this.form.language,
        template_id: this.template.id,
      };

      startAiTemplateGeneration(formData)
        .then(response => {
          if (response.data.success) {
            this.generation.id = response.data.id;
            this.generation.status = 'PENDING';

            this.generation.interval = setInterval(() => {
              this.checkGenerationStatus();
            }, 5000);
          }
        })
        .catch(error => {
          console.log(error);
          this.loading = false;
        });
    },
    checkGenerationStatus() {
      getAiTemplateGenerationStatus(this.generation.id)
        .then(response => {
          this.generation.status = response.data.status;

          if (this.generation.status === 'SUCCESS') {
            clearInterval(this.generation.interval);
            this.loading = false;
            this.generation.interval = null;

            // Redirect to the editor
            let home = response.data.website.layouts[0].pages.find(page => !!page.initial);
            let pageHome = home || response.data.website.layouts[0].pages[0];

            this.$router.push({ name: 'editor', params: { page_id: pageHome.encrypted_id } });
          }
          else if (this.generation.status === 'ERROR') {
            clearInterval(this.generation.interval);
            this.loading = false;
            this.generation.interval = null;
            alert(this.$t('ct-ai-error-to-generate-website'));
          }
        })
        .catch(error => {
          console.error(error);
        });
    },
    open() {
      this.$refs.modal.open();
    },
    close() {
      this.$refs.modal.close();
    }
  }
};
</script>

<style lang="scss" scoped>
.sweet-content-content {
  display: grid;
  gap: 16px;

  .popup-header {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 16px;
    border-bottom: 1px solid #4D5D7140;
    padding-bottom: 12px;
    position: relative;

    span, .skip-btn {
      color: #0072E1;
      text-transform: capitalize;
      font-size: 22px;
      font-weight: 600;
    }

    .skip-btn {
      position: absolute;
      right: 0;
      background: none;
      border: none;
      font-size: 14px;
    }
  }

  label {
    margin: 0;
    color: #111827;
    font-weight: 500;
    font-size: 14px;
  }

  button {
    outline: none;
  }

  .error-message {
    font-size: 11px;
  }

  .website-description-qty {
    font-size: 11px !important;
  }

  .prompt-status-box {
    display: flex;
    gap: 4px;
    margin-top: 2px;

    div {
      height: 3px;
      width: 100%;
      border-radius: 32px;
      background-color: #D0DAED;
    }

    &.red {
      .prompt-status-1{
        background-color: #FA4B57;
      }
    }

    &.yellow {
      .prompt-status-1,
      .prompt-status-2{
        background-color: #FFCC3F;
      }
    }

    &.green {
      .prompt-status-1,
      .prompt-status-2,
      .prompt-status-3{
        background-color: #20E4B3;
      }
    }
  }
  .instructions {
    color: #92AAC6;
    font-size: 11px;
  }

  .popup-body {
    p {
      color: #54779E;
      font-size: 14px;
      font-weight: 500;
    }

    .box-radio {
      .radio-grid {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        gap: 16px;

        label {
          font-size: 14px;
          align-items: center;
          display: flex;
          gap: 4px;
          color: #4D5D71;
          cursor: pointer;

          input {
            cursor: pointer;
          }
        }
      }
    }
    .quick-note {
      border: 1px solid #D0DAED;
      padding: 6px;
      border-radius: 12px;

      span {
        font-size: 12px;
      }
    }
  }
  .popup-bottom {
    display: grid;
    justify-content: center;
    align-items: center;
    gap: 4px;

    .generate-button {
      border-radius: 12px;
      padding: 8px 14px;
      border: 1px solid #0072E1;
      color: #0072E1;
      text-transform: uppercase;
      display: flex;
      justify-content: center;
      gap: 8px;
      align-items: center;
      background: none;
      font-weight: 600;
      font-size: 14px;

      &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/components/AiBusinessTemplatePopup.vue